import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import AllCategory from '@/assets/images/category/all-category.png';
import { cn } from '@/lib/utils';
import { getFileUrl } from '@/services/CommonService';

const POSCategoriesSlider = ({ dataCategorySource, categoriesSelectedValue, setCategoriesSelectedValue }) => {
    return (
        <div className={`swiper pos-menu-swiper mb-6 ${dataCategorySource.length > 1 ? '' : 'hidden'}`}>
            <Swiper dir="ltr" speed={1000} slidesPerView="auto" spaceBetween={16} className="menu-slides">
                <SwiperSlide key={0} className={cn('!w-fit', categoriesSelectedValue === 0 && 'pos-group')}>
                    <button
                        onClick={() => setCategoriesSelectedValue(0)}
                        className={cn(
                            'w-28 flex flex-col items-center text-center gap-4 py-4 px-3 rounded-lg border-b-2 border-transparent transition hover:bg-primary-light hover:border-primary bg-white',
                            categoriesSelectedValue === 0 && 'active'
                        )}>
                        <img className="h-7 drop-shadow-category" src={AllCategory} alt="category" />
                        <h3 className="text-xs leading-[16px] font-medium font-rubik">{'All Items'}</h3>
                    </button>
                </SwiperSlide>
                {dataCategorySource &&
                    dataCategorySource.length > 0 &&
                    dataCategorySource.map((category, index) => (
                        <SwiperSlide key={category?._id} className={cn('!w-fit', categoriesSelectedValue === category?._id && 'pos-group')}>
                            <button
                                onClick={() => setCategoriesSelectedValue(category?._id)}
                                className={cn(
                                    'w-28 flex flex-col items-center text-center gap-4 py-4 px-3 rounded-lg border-b-2 border-transparent transition hover:bg-primary-light hover:border-primary bg-white',
                                    categoriesSelectedValue === category?._id && 'active'
                                )}>
                                <img className="h-7 drop-shadow-category" src={getFileUrl(category?.file_name, 'productCategory')} alt="category" />
                                <h3 className="text-xs leading-[16px] font-medium font-rubik">{category?.name}</h3>
                            </button>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
};

export default POSCategoriesSlider;
